<nav #panel id="cub-side-sub-menu" class="sub-menu" [attr.aria-label]="label + ' submenu'"
     (pointerenter)="onPointerEnter($event)" (pointerleave)="onPointerLeave($event)">
  <div *ngFor="let current of [page]" class="menu-page" [class.menu-page-back]="current.direction === 'back'">
    <button *ngIf="level > 0" type="button" class="menu-back" (click)="backMenu()">
      <fa-icon [icon]="faCaretLeft"></fa-icon> Back to Menu
    </button>
    <ng-container *ngFor="let item of current.items">
      <a *ngIf="item.external && item.subMenu.length === 0"
         [href]="item.link" target="_blank" rel="noopener noreferrer"
         (click)="openExternal($event, item)">
        {{ item.name }} <i class="fa fa-external-link" aria-hidden="true"></i>
      </a>
      <a *ngIf="!item.external && item.subMenu.length === 0"
         [routerLink]="item.link" routerLinkActive="active"
         (click)="hideMenu(item)">
        {{ item.name }}
      </a>
      <button *ngIf="!item.separator && item.subMenu.length > 0 && !item.isCustom"
              type="button" class="menu-branch" (click)="menuClick(item)">
        <span>{{ item.name }}</span>
        <i class="fa fa-caret-right" aria-hidden="true"></i>
      </button>
    </ng-container>
  </div>
</nav>
